import { useTheme } from '@flik/shared';
import React from 'react';

interface SetThemeHeaderProps {
  onBackClick?: () => void;
  actionTitle?: string;
}

const SetThemeHeader: React.FC<SetThemeHeaderProps> = ({
  onBackClick,
  actionTitle = 'Set theme',
}) => {
  const { provideTailwind } = useTheme();

  return (
    <>
      {/* Back button - only show if onBackClick is provided */}
      {onBackClick && (
        <div
          className={`mr-3 ${provideTailwind(
            'text-primary',
          )} flex items-center`}
        >
          <button
            onClick={onBackClick}
            className={`p-2 rounded-lg transition-colors cursor-pointer window-no-drag ${provideTailwind(
              'hover:bg-back-button',
            )}`}
            title="Back to search"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        </div>
      )}

      {/* Title */}
      <div className="flex-1 flex items-center">
        <h2
          className={`${provideTailwind(
            'text-primary',
          )} text-base sm:text-sm font-medium leading-none`}
        >
          {actionTitle}
        </h2>
      </div>
    </>
  );
};

export { SetThemeHeader };
